"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_MEDIA_SIZE_SLUG = void 0;
const DEFAULT_MEDIA_SIZE_SLUG = 'full';
exports.DEFAULT_MEDIA_SIZE_SLUG = DEFAULT_MEDIA_SIZE_SLUG;
//# sourceMappingURL=constants.js.map